<template>
     <b-form-row class="header-register my-4 " no-gutters >

    <b-col cols="9">
          <img src="@/assets/img/svgs/arrow-left.svg" alt="" @click="$router.replace(data.router)" class="arrow"/>
      <p class="mb-0 f-default title ml-4">
        {{ data.title }} <br>
      <span class="resume f-default">
        {{ data.resume }}
      </span>
      </p>
    </b-col>
      <b-col cols="3"  >
      <slot />
    </b-col>
  
  </b-form-row>
</template>
<script>
export default {
  props:{
      data:{
          type:Object,
      }
  }
};
</script>
<style lang="scss">
.header-register {
    button{
        width: 100%;
    }
    .arrow{
        cursor: pointer;
        position: absolute;
        top: 5px;
    }
  .title {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
  }
  .resume {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #6C757D;
  }
}
</style>